export const environment = {
  i18nBaseUrl: process.env.I18N_BASE_URL || '',
  pssEndpointUrl: process.env.PSS_ENDPOINT_URL || 'https://graphql.dev-pss.audi.com',
};

export const currentEnvironment = process.env.STAGE || 'prod';

const apiBaseUrl: Record<string, string> = {
  local: 'http://localhost:8000/api/v1',
  dev: 'https://fa-dealer-search.api.dev.arcade.apps.one.audi/api/v1',
  prod: 'https://fa-dealer-search.api.prod.arcade.apps.one.audi/api/v1',
};

export const currentApiBaseUrl = apiBaseUrl[currentEnvironment];
